<template>
    <div v-if="block.display" class="home-block" v-observe-visibility="{
            callback: visibilityChanged,
            once: true,
            intersection:{
                rootMargin: `${block.observeMargin}px 0px ${block.observeMargin}px 0px`
            }
        }" :id="block.elementId">
        <h2 v-html="block.title"></h2>
        <div class="home-block-content">
            <div v-show="backShow" class="block-back" @click="back">
                <span class=" ecom-chevron-left"></span>
            </div>
            <div class="banner-content mt-0" ref="block" @scroll="scrollEvent">
                <div class="slider-margin">&nbsp;</div>
                <div v-if="block.isLoading" class="banner-item-slide" :style="{height: `${bannerHeight}px`}">
                    <div v-for="n in Math.ceil(nImages)" class="banner-item" :key="n" :style="{width: `${bannerWidth}px`,height: `${bannerHeight}px`}">
                        <div class="banner-item-border w-100 h-100 skeleton-box"></div>
                    </div>
                </div>
                <div v-for="banner in block.dataContent" :key="banner.campaignId" class="banner-item-slide banner-item" :style="{width: `${bannerWidth}px`,height: `${bannerHeight}px`}" @click.ctrl="() => {return true;}" @click.exact="gotoUrl(banner.url)">
                    <a v-if="banner.url && banner.url!='#'" :href="banner.url" :data-qa-href="banner.urlQaTest" class="w-100 h-100 slider-item-href" :aria-label="imgAlt(banner.url)">&nbsp;</a>
                    <div class="banner-item-border w-100">
                        <BlockImage :classNames="'w-100'" :classNamesBox="'w-100 h-100'" :isScrolled="isScrolled" :image="banner.image" :title="imgAlt(banner.url)" :width="bannerWidth" :height="bannerHeight" :webpAllowed="false"></BlockImage>
                    </div>
                    <Video v-if="banner.video" :vWidth="bannerHeight" :source="banner.video" :url="banner.url" :color="colorBanner(banner)"></Video>
                    <TimeCounter v-if="banner.timeCounter" :vWidth="bannerHeight" :timeCounter="banner.timeCounter"></TimeCounter>
                </div>
                <div class="slider-margin">&nbsp;</div>
            </div>
            <div v-show="nextShow" class="block-next" @click="forward">
                <span class=" ecom-chevron-right"></span>
            </div>
        </div>
    </div>
</template>
<script>
import BlockImage from '../../Common/Partials/BlockImage';
import HomeBlock from '@/models/home-block';
import homeUtils from '@/Utilities/homeUtils';
import Video from '../../Common/Partials/VideoBanner';
import TimeCounter from '../../Common/Partials/TimeCounter';
export default {
    components:{
        BlockImage,
        TimeCounter,
        Video
    },
    props:{
        block:{
            type: HomeBlock
        },
        margin:{
            type: Number,
            default: 3
        },
        defaultWidth:{
            type: Number,
            default: 824
        },
        defaultHeight:{
            type: Number,
            default: 410
        },
        borderWidth:{
            type: Number,
            default: 2
        }
    },
    data(){
        return{
            bannerWidth: 0,
            bannerHeight: 0,
            backShow: false,
            nextShow: false,
            bannerSelected: 0,
            viewWidth: 0,
            isScrolled: false
        }
    },
    mounted() {
        this.resize();
    },
    created() {
        window.addEventListener("resize", this.resize);
    },
    updated(){
        const elem = this.$refs.block;
        if(elem && elem.scrollLeft == 0){
            this.nextShow = this.block.length > this.nImages;
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.resize);
    },
    computed: {
        nImages(){
            return this.block.numberItens;
        }
    },
    methods: {
        visibilityChanged(isVisible){
            if(isVisible){
                this.block.load();
            }
        },
        imgAlt(url){
            return url.replace(/\//g,' ').replace(/-/g,' ');
        },
        gotoUrl(url){
            homeUtils.gotoUrl(url,this.block);
        },
        colorBanner(banner){
            return banner.hasOwnProperty('css_class') && banner.css_class && banner.css_class.hasOwnProperty('slide_bgcolor') ? banner.css_class.slide_bgcolor : null;
        },
        resize(){
            let isMobile        = this.block.platform == 2;
            this.viewWidth      = homeUtils.getViewPortWidth(isMobile);
            let marWidth        = Math.round(this.viewWidth * (this.margin * 2 / 100));
            let bWidth          = (this.viewWidth - marWidth) / this.nImages;
            this.bannerWidth    = Math.round(bWidth);
            this.bannerHeight   = this.defaultHeight * (this.bannerWidth - (this.borderWidth * 2)) / this.defaultWidth;
            if(this.bannerHeight > this.defaultHeight){
                this.bannerHeight = this.defaultHeight;
            }
        },
        scrollEvent(){
            const elem    = this.$refs.block;
            let marWidth  = Math.round(this.viewWidth * (this.margin * 2 / 100));
            const pos     = (elem.scrollLeft - marWidth) / this.bannerWidth;
            this.bannerSelected = Math.round(pos);
            this.nextShow = elem.scrollWidth > elem.scrollLeft + this.viewWidth + 10;
            if(!this.nextShow){
                const bnrs  = elem.querySelectorAll('.banner-item-slide');
                this.bannerSelected = bnrs.length - Math.floor(this.nImages);
            }
            this.backShow = elem.scrollLeft > 10;
            if(!this.backShow){
                this.bannerSelected = 0;
            }
            this.isScrolled = true;
        },
        back(){
            this.scrollMove(-1);
        },
        forward(){
            this.scrollMove(1);
        },
        scrollMove(direction){
            const elem  = this.$refs.block;
            const bnrs  = elem.querySelectorAll('.banner-item-slide');
            if(direction > 0 && this.bannerSelected>=(bnrs.length - 1)){
                return;
            }
            if(direction < 0 && this.bannerSelected<=0){
                return;
            }
            this.bannerSelected = this.bannerSelected + direction;
            let margin = Math.round(this.viewWidth * (this.margin / 100));
            let value  = bnrs[this.bannerSelected].offsetLeft - margin;
            this.smoothScrolling(elem,value);
        },
        smoothScrolling(e,value){
            e.scrollTo({
                top: 0, 
                left: value,
                behavior: 'smooth'
            });
        },
    }
}
</script>